var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMonthly = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 82,
    viewBox: "0 0 88 82",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#89B6DE",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.8,
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.664 6.564H15.828M48.868 6.564h-13.06M68.516 6.564H55.792M8.908 6.564h-2.7c-3.314 0-6 2.686-6 6v60c0 3.314 2.686 6 6 6h72.04c3.314 0 6-2.686 6-6v-60c0-3.314-2.686-6-6-6h-2.7"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.264,
    height: 9.264,
    x: 8.908,
    y: 28.776,
    rx: 1.184
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.264,
    height: 9.264,
    x: 27.572,
    y: 28.776,
    rx: 1.184
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.264,
    height: 9.264,
    x: 46.24,
    y: 28.776,
    rx: 1.184
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.264,
    height: 9.264,
    x: 64.908,
    y: 28.776,
    rx: 1.184
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.264,
    height: 9.264,
    x: 8.908,
    y: 45.296,
    rx: 1.184
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.264,
    height: 9.264,
    x: 27.572,
    y: 45.296,
    rx: 1.184
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.264,
    height: 9.264,
    x: 46.24,
    y: 45.296,
    rx: 1.184
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.264,
    height: 9.264,
    x: 64.908,
    y: 45.296,
    rx: 1.184
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.264,
    height: 9.264,
    x: 8.908,
    y: 61.932,
    rx: 1.184
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.264,
    height: 9.264,
    x: 27.572,
    y: 61.932,
    rx: 1.184
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.264,
    height: 9.264,
    x: 46.24,
    y: 61.932,
    rx: 1.184
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.112 21.588h7.144M66.508 21.588h5.024M11.476 21.588h49.116M.424 21.588h5.468"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.364,
    height: 12.392,
    x: 9.296,
    y: 0.2,
    rx: 3.18
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.364,
    height: 12.392,
    x: 29.132,
    y: 0.2,
    rx: 3.18
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.364,
    height: 12.392,
    x: 48.964,
    y: 0.2,
    rx: 3.18
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.364,
    height: 12.392,
    x: 68.796,
    y: 0.2,
    rx: 3.18
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMonthly, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/monthly.b0fdbbeb.svg";
export { ForwardRef as ReactComponent };